import { render } from "./DgvtLegal.vue?vue&type=template&id=46392cce"
import script from "./DgvtLegal.vue?vue&type=script&lang=js"
export * from "./DgvtLegal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/dgvt/dgvt-fuchs.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__